export default "__VITE_ASSET__Bi6A2PZe__"